exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb_20[data-v-3fa8a296] {\n  margin-bottom: 0.104167rem;\n}\n.label[data-v-3fa8a296] {\n  margin-bottom: 0.052083rem;\n}\n[data-v-3fa8a296] .el-dialog {\n  width: 3.125rem;\n}", ""]);

// exports
